import { render, staticRenderFns } from "./triangle_polygon.vue?vue&type=template&id=03bd1246&"
import script from "./triangle_polygon.vue?vue&type=script&lang=js&"
export * from "./triangle_polygon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports